import { __awaiter } from "tslib";
import { logger } from '@lusha/client-logger';
import { startIdleLogout } from '@lusha/idle-management';
import { fetchUserCompanyInfo } from '../../API/userAPI';
import { dismissNotifications } from '../../hooks/useNotification';
import { CacheRepository } from '../../utils/cache/cacheRepository';
import { CACHE_KEYS_TO_INVALIDATE_ON_LOGOUT } from '../../utils/cache/cacheStore';
import { actions } from './reducer';
import { selectIsIdleLogoutEnabled } from './selectors';
class Dispatcher {
    constructor() {
        this.actions = actions;
    }
    load(user) {
        return dispatch => {
            dismissNotifications();
            dispatch(actions.setUser(user));
            dispatch(this.fetchCompanyInfo());
            dispatch(this.startIdleLogout());
        };
    }
    logout() {
        return dispatch => {
            CACHE_KEYS_TO_INVALIDATE_ON_LOGOUT.forEach(cacheKey => CacheRepository.remove(cacheKey));
            dispatch(actions.loggedOut());
        };
    }
    /** Safe to call on every load: the library guards itself with `window.idleLogoutInitialized`. */
    startIdleLogout() {
        return (dispatch, getState) => {
            const { user } = getState();
            if (selectIsIdleLogoutEnabled(user)) {
                startIdleLogout({ idleTime: user.idleLogoutTimeMinutes });
            }
        };
    }
    /** Company size is only needed for admins on a paid plan (the "grow your account" banner). */
    fetchCompanyInfo() {
        return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const { user } = getState();
            if (!user.isAccountAdmin || !((_a = user.billing) === null || _a === void 0 ? void 0 : _a.isPaid) || user.company.isLoaded) {
                return;
            }
            logger.info(`Fetching ${user.email} company's data`);
            try {
                const response = yield fetchUserCompanyInfo();
                dispatch(actions.setCompanyInfo({
                    isLoaded: true,
                    minSize: (_b = response === null || response === void 0 ? void 0 : response.companySize) === null || _b === void 0 ? void 0 : _b.min,
                    maxSize: (_c = response === null || response === void 0 ? void 0 : response.companySize) === null || _c === void 0 ? void 0 : _c.max,
                }));
            }
            catch (error) {
                logger.warn("couldn't fetch user's company info", { error });
            }
        });
    }
}
const UserDispatcher = new Dispatcher();
export default UserDispatcher;
